import { Component, OnInit } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-unavailable503',
  templateUrl: './unavailable503.component.html',
  styleUrls: ['./unavailable503.component.scss'],
})
export class Unavailable503Component implements OnInit {
  message: any;
  tenantID: any;
  propertyID: any;
  constructor(public appinit: LegacyBookInitService, toast: ToastrService) {
    if (
      this.appinit.tenantNotFoundData &&
      !this.appinit.tenantNotFoundData.Success &&
      this.appinit.tenantNotFoundData.Success != undefined
    ) {
      this.message = this.appinit.tenantNotFoundData.ErrorMessage.substring(0, this.appinit.tenantNotFoundData.ErrorMessage.indexOf('-'))
        ? this.appinit.tenantNotFoundData.ErrorMessage.substring(0, this.appinit.tenantNotFoundData.ErrorMessage.indexOf('-'))
        : this.appinit.tenantNotFoundData.ErrorMessage;
      this.tenantID = this.appinit.tenantId;
      this.propertyID = this.appinit.propertyId;
    }
  }

  ngOnInit() {
    var preloader = document.querySelector('.preloaderapp');
    if (preloader) {
      preloader.className = ' preloaderapp-hidden-add preloaderapp-hidden-add-active';
    }
  }
}
